import { type FC, useEffect, useMemo, useState } from 'react';
import VerticalStepper from '../../../../../components/VerticalStepper/VerticalStepper';
import { getOrderHistoryWithShipments } from '../../../../../services/suscription/history.service';
import type { IOrderHistoryWithShipmentsResponse } from '../../../../../types/order-status-log.types';
import type { IShipmentData } from '../../../../../types/orders';
import { displayErrorNotification } from '../../../../../utils/displayNudosStandardNotifications';
import { transformOrderStatusLogHistoryToSteps, getShipmentDestinationLabel } from './orderStatusLogStepper.utils';

import './Tab5OrderStatusLogHistory.scss';

interface ITab5OrderStatusLogHistoryProps {
  orderId: string;
  /** Datos de envíos de la orden para mostrar "Envío a Pepito Perez" / "Envío a bodega" / "Envío a oficina" en lugar de "Envío #n" */
  shipmentData?: IShipmentData[] | null;
}

const Tab5OrderStatusLogHistory: FC<ITab5OrderStatusLogHistoryProps> = ({ orderId, shipmentData }) => {
  const [data, setData] = useState<IOrderHistoryWithShipmentsResponse | null>(null);
  const [loading, setLoading] = useState(true);

  const shipmentLabels = useMemo(() => {
    if (!shipmentData?.length) return undefined;
    return Object.fromEntries(shipmentData.map(s => [s.shipmentId, getShipmentDestinationLabel(s)])) as Record<
      number,
      string
    >;
  }, [shipmentData]);

  const orderHistory = data?.orderHistory ?? [];
  const shipments = data?.shipments ?? [];
  const steps = transformOrderStatusLogHistoryToSteps(orderHistory, shipments, shipmentLabels);

  const renderContent = () => {
    if (loading) return <p className="emptyStateText">Cargando historial...</p>;
    if (!data) return <p className="emptyStateText">No hay historial disponible para esta orden</p>;
    return <VerticalStepper steps={steps} />;
  };

  useEffect(() => {
    if (!orderId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    getOrderHistoryWithShipments(Number(orderId))
      .then(setData)
      .catch(() => displayErrorNotification())
      .finally(() => setLoading(false));
  }, [orderId]);

  return (
    <div className="tab5History tab5OrderStatusLogHistory">
      <h2 className="title">Historial de la orden</h2>
      <div className="boxDetails">{renderContent()}</div>
    </div>
  );
};

export default Tab5OrderStatusLogHistory;
